
import React from 'react';
export default function Blog014() {
  return (
    <section>
    <article>
      <h2>14. 09-14-2022</h2>
      <h3>Oh hello September</h3>
      <p>
       Alright, it has been a few days since I have written a blog or recorded a vlog.
       I have been working on a few projects at Javascript30.com where you create 30 javascript projects in 30 days. 
       I am not sure if I will keep on pace for creating 30 in 30, but this is great practice and learning to add to my current toolbelt. 
       <br />
       <br />
       I should mention I gave myself a bit of a short time to write this blog, so I will try to keep it short. I is important to me to keep up on 
        the blog and vlog as consistently as possible. 
        <br />
        I have started to learn bootstrap. I enjoy what I have learned so far, 
        and I think it is a great way to learn and keep a consistent pattern of naming 
        assets throughout the project. This is my secondary focus currently. 
        <br />
        <br />
        I imported the npx react file. There is a lot going on here. I am debating on creating my own Javascript Library. 
        Though for now, I don't want to try to learn too many things at once. So 
        I will start with Javascript frameworks after I have a decent grasp on bootstrap.
        <br />
        <br />
        I have a few projects in my notebook that I would like to work on. I am 
        currently working with a gentleman on Discord to create a web based game 
        that I have pulled from my notebook. We have mostly spoke concepts and theoretical ideas, but it has been a fun experience. 
        Talking with him gave me the idea to look into frameworks that I spoke of earlier. 
        <br />
        <br />
        Long story short, I didn't fall off a bridge somewhere. I am still sitting in front of the computer.
        Infact, with September here, my schedule has cleared up a bit enabling me 
        to focus on coding more than ever. I have big plans for the next month, and I am 
        excited to get into it!
      </p>
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
        rel="noopener noreferrer" 
          href="http://ericpolley.com"
          title="My website"
          target="_blank"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
